document.addEventListener('DOMContentLoaded', () => {
  const revealDelayMs = 20000;
  const hideChatWidgets = () => {
    const selectors = [
      "iframe[src*='willdesk']",
      "iframe[src*='tidio']",
      "[id*='willdesk']",
      "[class*='willdesk']",
      "[id*='tidio']",
      "[class*='tidio']",
      'shopify-chat',
      "[id*='shopify-chat']",
      "[class*='shopify-chat']",
      "[class*='shopify-inbox']",
    ];

    document.querySelectorAll(selectors.join(',')).forEach((element) => {
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });
  };

  hideChatWidgets();

  const observer = new MutationObserver(() => {
    hideChatWidgets();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setInterval(hideChatWidgets, 1500);

  document.querySelectorAll('[data-partner-help-popup]').forEach((popup) => {
    const openButtons = popup.querySelectorAll('[data-partner-help-open]');
    const closeButton = popup.querySelector('[data-partner-help-close]');
    const panel = popup.querySelector('.partner-help-popup__panel');

    if (!openButtons.length || !closeButton || !panel) return;

    const setOpen = (isOpen) => {
      popup.classList.toggle('is-open', isOpen);
      openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        window.requestAnimationFrame(() => {
          closeButton.focus({ preventScroll: true });
        });
      }
    };

    window.setTimeout(() => {
      popup.classList.add('is-ready');
    }, revealDelayMs);

    panel.setAttribute('aria-hidden', 'true');

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setOpen(!popup.classList.contains('is-open'));
      });
    });

    closeButton.addEventListener('click', () => {
      setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!popup.contains(event.target)) setOpen(false);
    });
  });
});
